import React, {Component} from 'react'
import {
    NavBar,
    Icon,
    List,
    Toast,
    WhiteSpace,
    SearchBar,
    ActionSheet,
    Radio
  } from 'antd-mobile'
import './SelectPrefixList.scss'
import axios from "@/service/axios";
import NoneDatas from "@/components/noneDatas";
import { connect } from "dva";
const Item = List.Item;
const Brief = Item.Brief;

export class SelectPrefixList extends Component {
  state = {
    pageNo: 1,
    pageTotalNum: 0,
    prefixDatas: [],
    getICCID:'',
    name:''
  }
  componentDidMount(){
    this.getPrefixListDatas()
  }
  // 获取前缀列表
  getPrefixListDatas(){
    axios.post('/api/group/prefixname/list',{
      prefixName:this.state.name
    })
      .then( res => {
        if(res && res.status === 200){
          if(res.data.length!=0){
            console.log("res",res)
            this.setState({
              prefixDatas: res.data
            })
          }
          else{
            this.setState({
              prefixDatas: []
            })
            Toast.fail('暂无数据!');
          }
        }else{
          console.log("res",res)
          Toast.fail(res.message);
        }
      })
  }
  // 点击前缀列表唤起动作面板
  showActionSheet(item){
    const BUTTONS = ['选择该前缀','详情', '取消'];
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      message: '操作"'+item.prefixName+'"',
      maskClosable: true,
      'data-seed': 'logId',
    },
    (buttonIndex) => {
      console.log(buttonIndex)
      if(buttonIndex == 0){
        this.props.addDefaultGroup(item)
        this.props.handleChildClose()
      }else if (buttonIndex == 1){
        // 查看详情页面
        this.props.history.push('/groupPrefixDetails?'+ item.prefixName)
      }
    });
  }
  
  // 精确查询前缀
  submit(val){
    this.setState({
      name:val
    },()=>{
      this.getPrefixListDatas()
    })
  }
  checkIccid(prefixName){
    axios.post('/api/group/prefixname/members/iccid',{
      iccid:this.state.getICCID
    })
    .then(res=>{
      console.log(res)
      if(res.status == 200){
        console.log(res)
        this.props.history.push(`/prefixInfo/${prefixName}/${this.state.getICCID}`)
      } else {
        Toast.fail(res.message,1)
      }
    })
  }

  
  render() {
    const {
      prefixDatas,
    } = this.state 
    const { addDefaultGroup, defaultGroup, prefixName} = this.props

    
    return (
      <div className='groupPrefixList'>
        <div className="header-sticky">
            <NavBar
              icon={<Icon type="left" />}
              onLeftClick={() => window.history.go(-1)}
              
            >
            前缀列表
          </NavBar>
          <SearchBar
            onSubmit={value => this.submit(value)}
            placeholder="输入前缀查询" 
            />
        </div>
        <div className='prefixList'
          style={{
            height: document.body.clientHeight - 80,
            overflow: "scroll"
          }}
        >
          <List renderHeader={() => "请选择一个群组前缀"}>
            {prefixDatas.length == 0 ? <NoneDatas/>:null}
            {prefixDatas.map((item, index) => (
              <Item
                key={index}
                arrow="horizontal"
                onClick={() => {
                  this.showActionSheet(item)
                }}
              >
                {item.prefixName}
              </Item>
            ))}
          </List>
          <WhiteSpace size="xl" />
          <WhiteSpace />
          {/* 没有分页 */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectPrefixList);

